import DoubleLeftArrowIcon from "./icons/DoubleLeftArrowIcon";
import LeftArrowIcon from "./icons/LeftArrowIcon";
import RightArrowIcon from "./icons/RightArrowIcon";
import DoubleRightArrowIcon from "./icons/DoubleRightArrowIcon";
import { Text } from "./text";

type Props = {
  currentPage: number;
  totalPages: number;
  displayPageNum?: number;
  onChange: (page: number) => void;
};

const CustomPagination = ({
  currentPage,
  totalPages,
  displayPageNum = 10,
  onChange,
}: Props) => {
  const showLeft = currentPage <= 1;
  const showRight = currentPage >= totalPages;
  const showLotLeft = currentPage <= 1;
  const showLotRight = currentPage >= totalPages;

  const getPageNumbers = () => {
    const numbers = [];
    const startValue =
      currentPage % displayPageNum === 0
        ? currentPage - displayPageNum
        : currentPage - (currentPage % displayPageNum);
    const value = startValue + 1;
    for (let i = 0; i < displayPageNum && i + value <= totalPages; i++) {
      numbers.push(value + i);
    }
    return numbers;
  };

  const isCurrentPage = (number: number) =>
    number === currentPage ? "active" : "";

  const clickPage = (pageNum: number) => {
    if (onChange) {
      onChange(pageNum);
    }
  };

  const clickLeft = () => {
    if (currentPage > 1 && onChange) {
      onChange(currentPage - 1);
    }
  };

  const clickRight = () => {
    if (currentPage < totalPages && onChange) {
      onChange(currentPage + 1);
    }
  };

  const clickPageLeft = () => {
    if (currentPage > 1 && onChange) {
      const value = currentPage - displayPageNum;
      onChange(value < 1 ? 1 : value);
    }
  };

  const clickPageRight = () => {
    if (currentPage < totalPages && onChange) {
      const value = currentPage + displayPageNum;
      onChange(value > totalPages ? totalPages : value);
    }
  };

  return (
    <div className="flex">
      <ul className="flex list-none p-0">
        <li
          className={`w-10 h-10 flex items-center justify-center ${
            showLotLeft ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          <button
            type="button"
            onClick={clickPageLeft}
            disabled={showLotLeft}
            className="cursor-pointer"
          >
            <DoubleLeftArrowIcon color={!showLotLeft ? "#666666" : "#CCCCCC"} />
          </button>
        </li>
        <li
          className={`w-10 h-10 flex items-center justify-center ${
            showLeft ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          <button
            type="button"
            onClick={clickLeft}
            disabled={showLeft}
            className="cursor-pointer"
            data-testid="prev-button"
          >
            <LeftArrowIcon color={!showLeft ? "#666666" : "#CCCCCC"} />
          </button>
        </li>
        {getPageNumbers().map((number) => (
          <li
            key={number}
            className="w-10 h-10 flex items-center justify-center"
          >
            <button
              type="button"
              onClick={() => clickPage(number)}
              data-testid={`button-${number}`}
              className={`relative border-none flex w-7 px-2 py-1 flex-col justify-center items-center rounded-lg ${
                isCurrentPage(number) === "active" ? "bg-grey-90 " : ""
              }`}
            >
              <Text
                variant={"label-lg"}
                className={
                  isCurrentPage(number) === "active"
                    ? "text-grey-30"
                    : "text-grey-40"
                }
              >
                {number}
              </Text>
            </button>
          </li>
        ))}
        <li
          className={`w-10 h-10 flex items-center justify-center ${
            showRight ? "opacity-50 cursor-not-allowed" : ""
          }`}
          data-testid="next-button"
        >
          <button
            type="button"
            onClick={clickRight}
            disabled={showRight}
            className="cursor-pointer"
          >
            <RightArrowIcon color={!showRight ? "#666666" : "#CCCCCC"} />
          </button>
        </li>
        <li
          className={`w-10 h-10 flex items-center justify-center ${
            showLotRight ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          <button
            type="button"
            onClick={clickPageRight}
            disabled={showLotRight}
            className="cursor-pointer"
          >
            <DoubleRightArrowIcon
              color={!showLotRight ? "#666666" : "#CCCCCC"}
            />
          </button>
        </li>
      </ul>
    </div>
  );
};

export default CustomPagination;
